import { render, staticRenderFns } from "./SegmentEdit.vue?vue&type=template&id=a377bda8&scoped=true&"
import script from "./SegmentEdit.vue?vue&type=script&lang=js&"
export * from "./SegmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./SegmentEdit.vue?vue&type=style&index=0&id=a377bda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a377bda8",
  null
  
)

export default component.exports